import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import type { ProjectDocType } from '@ast-data/shared';
import { projectDisplayTitle } from '../projects/projectTitle';
import { FIELD_CATEGORIES } from './fieldCategories';
import type { FieldRoute } from './useFieldRoute';
import { APP_TITLE } from '../../utils/environment';

/**
 * Keeps the browser tab title on the open section, e.g.
 * "AST - Befunde - M_1234 - Kurztitel". The office Layout owns its own title;
 * the two apps never mount together, so each sets it for as long as it is up.
 */
export function useFieldDocumentTitle(
    route: FieldRoute,
    activeProject: ProjectDocType | null
): void {
    const intl = useIntl();
    const categoryLabelId = FIELD_CATEGORIES.find(
        (category) => category.key === route.category
    )?.labelId;
    const documentTitle = [
        APP_TITLE,
        intl.formatMessage({ id: categoryLabelId ?? 'field.title' }),
        projectDisplayTitle(activeProject)
    ]
        .filter(Boolean)
        .join(' - ');

    useEffect(() => {
        document.title = documentTitle;
    }, [documentTitle]);
}
